export default {
  uiLoadingState: false,
  isFirstLoading: true,
  ignoreAggregations: false,
  triggeredByBrowserUI: false,
  config: {
    baseUrl: '',
  },
  filters: {
    suggestions: { // From AbstractSearchApiDataBuilder
      jobJobRoles: [],
      reviewJobRoles: [],
      companyIndustries: [],
      reviewRegions: [],
    },
    jobRoles: {
      groups: [],
      values: [],
    },
    companyIndustries: [],
    jobTypes: [],
    best_apprenticeship_employers: [],
  },
  searchUrl: 'search-jobs', // This is in-fact and api url not a browser url
  // defaultUrls stands for: default search urls (eg: no filters applied)
  defaultUrls: [],
  sortingUrls: [],
  pauseQueryWatcher: false,
  pagination: {},
  query: {
    best_apprenticeship_employers: [],
    programme: [],
    discipline: [],
    disciplines_parent: false,
    location: '',
    // locations_parent: false,
    od: '',
    page: 1,
    s: '',
    show: '',
    radius: 10,
  },
  resultCount: 0,
  results: [],
  ajaxCancellationTokens: [],
  defaultSortOrders: {},
  services: {
    featuredResults: [],
  },
  dynamicHeaders: {
    heading: '',
    description: '',
  },
  locationsMeta: {},
};
